import Editor from "../../../form/Editor";
import FileUploadSingle from "../../../form/FileUploadSingle";
import Input from "../../../form/Input";

export const BlogPageForm = ({
  values,
  handleChange = () => {},
  errors,
  formValidate,
}) => (
  <div className="grid grid-cols-12 gap-4">
    <div className="relative col-span-6">
      <div className="relative col-span-12">
        <FileUploadSingle
          label={"Upload Blog Banner Image"}
          labelClasses={"!mb-2"}
          value={values?.blogBannerImage}
          onChange={(file) =>
            handleChange({ target: { name: "blogBannerImage", value: file } })
          }
          {...formValidate(errors, "blogBannerImage")}
        />
      </div>
      <Input
        label="Blog Title"
        inputPlaceholder="Enter Blog Title"
        inputName="blogTitle"
        value={values?.blogTitle || ""}
        onChange={handleChange}
        {...formValidate(errors, "blogTitle")}
      />
    </div>
    <div className="relative col-span-6">
      <Editor
        label="Blog Description"
        placeholder="Enter Blog Description"
        value={values?.blogDesc}
        onChange={(val) =>
          handleChange({
            target: { name: "blogDesc", value: val },
          })
        }
        {...formValidate(errors, "blogDesc")}
      />
    </div>
  </div>
);
